import React from 'react';
import '../../App.css';

export default function Services() {
    return <h1 className='services'>Welcome to Services: Click Get Started to continue to our services,
    Enjoy the best experience of gaming along with gaming
    ,Best for development among children....Wishing each user all the Best!!..Happy Learning :)</h1>
}